import './core/services/light.extenders';
import { CommonModule, Location } from '@angular/common';
import { CookieService } from 'ngx-cookie-service';
import {
  NgbActiveModal,
  NgbPaginationModule,
  NgbAccordionModule,
  NgbNav
} from '@ng-bootstrap/ng-bootstrap';
import {
  EventMessenager,
  UserService,
  TicketQueueService
} from '@sabstravtech/obtservices/angular';
import { A11yModule } from '@angular/cdk/a11y';
import { RouterModule } from '@angular/router';
import { GoogleMapsModule } from '@angular/google-maps';
// import { environment } from '../environments/environment';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatRadioModule } from '@angular/material/radio';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTabsModule, MAT_TABS_CONFIG } from '@angular/material/tabs';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { ServiceWorkerModule } from '@angular/service-worker';

import { OverRiddenModule } from './overridden/overridden.module';
import { StartupModule } from './startup/startup.module';
import { AppComponent } from './core/components/app-component/app.component';
import { CookieComponent } from './core/components/cookie-component/cookie.component';
import { ModalModule } from './modal/modal.module';
import { ThemeComponent } from './core/components/theme/theme.component';
import { ModalOpenerComponent } from './core/components/modal-opener/modal-opener.component';
import { LanguageService } from './core/services/language.service';
import { DDAService } from './core/services/dda.service';
import { TranslateCSVLoader } from './core/classes/translate-csv-locader';
import { ChangeUserComponent } from './core/components/change-user/change-user.component';
import { BecomeUserComponent } from './core/components/change-user/become-user/become-user.component';
import { AppRoutingModule } from './app-routing.module';
// import { AuthModule, provideAuth0 } from '@auth0/auth0-angular';

export function CSVLoaderFactory(httpClient: HttpClient) {
  return new TranslateCSVLoader(httpClient, 'assets/i18n/translations.csv');
}

const DECLARATIONS = [
  AppComponent,
  ModalOpenerComponent,
  ChangeUserComponent,
  ThemeComponent,
  BecomeUserComponent,
  CookieComponent
];

const SERVICES = [];
@NgModule({
  imports: [
    A11yModule,
    AppRoutingModule,
    RouterModule,
    BrowserModule,
    BrowserAnimationsModule,
    CommonModule,
    FontAwesomeModule,
    FormsModule,
    InfiniteScrollModule,
    MatButtonModule,
    MatSnackBarModule,
    MatButtonToggleModule,
    MatCheckboxModule,
    MatDialogModule,
    MatDividerModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatInputModule,
    MatMenuModule,
    MatRadioModule,
    MatIconModule,
    MatSelectModule,
    MatSlideToggleModule,
    MatTabsModule,
    GoogleMapsModule,
    ModalModule,
    OverRiddenModule,
    ReactiveFormsModule,
    StartupModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: CSVLoaderFactory,
        deps: [HttpClient]
      }
    }),
    ServiceWorkerModule.register('ngsw-url-exclusion.js', {
      enabled: true,
      // Register the ServiceWorker as soon as the app is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerImmediately'
    })
  ],
  declarations: [...DECLARATIONS],
  providers: [
    {
      provide: MAT_TABS_CONFIG,
      useValue: { contentTabIndex: 0 }
    },
    // Components
    CookieService,
    DDAService,
    EventMessenager,
    Location,
    LanguageService,
    NgbActiveModal,
    NgbPaginationModule,
    NgbAccordionModule,
    NgbNav,
    UserService,
    TicketQueueService,
    ...SERVICES
  ],

  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule {}
